import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa";
import logo from "src/components/ui/images/logowhite.jpeg";

const Footer = () => {
  const navItems = [
    { name: "Home", href: "#home" },
    { name: "About", href: "#about" },
    { name: "Membership", href: "#membership" },
    { name: "Classes", href: "#classes" },
    //{ name: "Calendar", href: "#calendar" },
    { name: "Coaches", href: "#coaches" },
    { name: "Gallery", href: "#gallery" },
    { name: "Contact", href: "#contact" },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-black border-t border-red-600/20">
      <div className="container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Logo and Description */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-6">
              <div className="flex items-center justify-center mb-12 animate-fade-in">
                {/* Logo Image */}
                <img 
                  src={logo}
                  alt="Clara Boxing Academy Logo"
                  className="w-32 h-32 md:w-48 md:h-48 lg:w-56 lg:h-56 rounded-full border-4 border-white shadow-lg object-cover"
                />
              </div>
            </div>

            <p className="text-gray-300 text-lg leading-relaxed mb-6 max-w-md">
              A family-run boxing academy where youth, amateurs, and professionals 
              train in a focused, supportive environment. No matter your age, 
              experience, or goals, you're welcome here.
            </p>
            
            <div className="space-y-3">
              <div className="flex items-center text-gray-300">
                <MapPin className="text-red-600 mr-3" size={20} />
                <span>1950 N Ruby St Melrose Park, IL 60160</span>
              </div>
              <div className="flex items-center text-gray-300">
                <Phone className="text-red-600 mr-3" size={20} />
                <a href="tel:3128855934" className="hover:text-red-600 transition-colors">
                  (312) 885-5934
                </a>
              </div>
              <div className="flex items-center text-gray-300">
                <Mail className="text-red-600 mr-3" size={20} />
                <a href="mailto:claraboxingacademy@gmail.com" className="hover:text-red-600 transition-colors">
                  claraboxingacademy@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-xl mb-6">Quick Links</h3>
            <nav className="space-y-3">
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.href)}
                  className="block text-gray-300 hover:text-red-600 transition-colors duration-300 text-left"
                >
                  {item.name}
                </button>
              ))}
            </nav>
          </div>

          {/* Training Info */}
          <div>
            <h3 className="text-white font-bold text-xl mb-6">Training Hours</h3>
            <div className="space-y-3 text-gray-300">
              <div>
                <p className="font-semibold text-white">Monday - Friday</p>
                <p>5:00 PM - 9:00 PM</p>
              </div>
              <div>
                <p className="font-semibold text-white">Saturday</p>
                <p>Open on selected Saturdays</p>
              </div>
              <div>
                <p className="font-semibold text-white">Sunday</p>
                <p>Closed</p>
              </div>
            </div>

            <div className="mt-6">
              <h4 className="text-white font-semibold mb-3">Follow Us</h4>
              <div className="flex space-x-4">
                {/* Instagram */}
                <a
                  href="https://www.instagram.com/claraboxingacademy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-red-600 transition-colors transform hover:scale-110 duration-300"
                >
                  <FaInstagram size={24} />
                </a>
                {/* YouTube */}
                <a
                  href="https://www.youtube.com/channel/UCfmGec-zhAcD9jnWk80nOLQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-red-600 transition-colors transform hover:scale-110 duration-300"
                >
                  <FaYoutube size={24} />
                </a>
                {/* TikTok */}
                <a
                  href="https://www.tiktok.com/@claraboxingacademy?_t=ZP-8zwun79pWHe&_r=1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-red-600 transition-colors transform hover:scale-110 duration-300"
                >
                  <FaTiktok size={24} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-center md:text-left mb-4 md:mb-0">
              <p className="text-gray-400">
                © 2026 Clara Boxing Academy. All Rights Reserved.
              </p>
            </div>
            
            <div className="flex items-center space-x-6">
              <div className="bg-red-600 text-white px-4 py-2 rounded-lg">
                <span className="font-bold"> 3 Days FREE Trial</span>
              </div>
              <div className="text-gray-400">
                <span>No Contracts • Month-to-Month</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
